<mat-card>{{'customersReq' | translate}}</mat-card>


<div class="container" style="padding: 25px;">

  <mat-grid-list cols="5" rowHeight="50px">
    <mat-grid-tile colspan="2">
      <mat-form-field appearance="standard">
        <mat-label>{{'filter' | translate}}</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="2">
      <mat-form-field appearance="standard">
        <mat-label>{{'mandoob' | translate}}</mat-label>
        <mat-select [(value)]="selectedMandoob" (selectionChange)="onSelectMandoob()">
          <mat-option value="">{{'all' | translate}}</mat-option>
          <mat-option value="0">الرئيسي</mat-option>
          <mat-option *ngFor="let item of mandoobs" [value]="item.id">
            {{item.fullName}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'customerStatus' | translate}}</mat-label>
        <mat-select [(value)]="selectedStatus" (selectionChange)="selectChange()">
          <mat-option *ngFor="let status of customersStatus" [value]="status.id">
            {{status.name | translate}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>


  </mat-grid-list>

  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="editInfo">
        <th mat-header-cell *matHeaderCellDef> {{'edit' | translate}} </th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button (click)="edit(row)">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 25%;"> {{'name' | translate}} </th>
        <td mat-cell *matCellDef="let row" style="width: 30%;"> {{row.fullName}} </td>
      </ng-container>

      <ng-container matColumnDef="mobile">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%;"> {{'userName' | translate}} </th>
        <td mat-cell *matCellDef="let row" style="width: 30%;"> {{row.userName}} </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 15%;"> {{'email' | translate}} </th>
        <td mat-cell *matCellDef="let row" style="width: 20%;"> {{row.email}} </td>
      </ng-container>

      <ng-container matColumnDef="userCategoryId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%;"> {{'userCatg' | translate}} </th>
        <td mat-cell *matCellDef="let row" style="width: 10%;padding: 10px;">

          <mat-form-field appearance="standard">
            <mat-select [(value)]="row.userCategoryId">
              <mat-option *ngFor="let item of userCategory" [value]="item.id">
                {{item.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="mandoobId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%;"> {{'mandoob' | translate}} </th>
        <td mat-cell *matCellDef="let row" style="width: 10%;padding: 10px;">

          <mat-form-field appearance="standard">
            <mat-select [(value)]="row.mandoobId">
              <mat-option *ngFor="let item of mandoobs" [value]="item.id">
                {{item.fullName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="options">
        <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'options' | translate}} </th>
        <td mat-cell *matCellDef="let row;let i = index;" style="width: 10%;padding: 10px;">
          <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="update(row)">
              <mat-icon>save</mat-icon>
              {{'submit' | translate}}
            </button>



            <button mat-menu-item (click)="onDeactivate(row.id,row.approved)">

              <mat-icon *ngIf="selectedStatus == 0">done</mat-icon>
              <mat-icon *ngIf="selectedStatus == 1">block</mat-icon>

              <span *ngIf="selectedStatus == 1 ">{{'unActive' | translate}}</span>
              <span *ngIf="selectedStatus == 0 ">{{'activate' | translate}}</span>


            </button>

            <button mat-menu-item (click)="resetPassword(row)">
              <mat-icon>security</mat-icon>
              {{'resetPassword' | translate}}
            </button>

            <button mat-menu-item (click)="assignAssMandoob(row)">
              <mat-icon>assignment_ind</mat-icon>
              {{'assignAsMandoob' | translate}}
            </button>

            <button mat-menu-item (click)="logoutFromAllDevices(row)">
              <mat-icon>devices_other</mat-icon>
              {{'logoutFromAllDevices' | translate}}
            </button>

            <button mat-menu-item *ngIf="row.approved==0" (click)="onDelete(row.id)">
              <mat-icon>delete</mat-icon>
              {{'delete' | translate}}
            </button>

          </mat-menu>
        </td>
      </ng-container>

      <!-- <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'update' | translate}} </th>
        <td mat-cell *matCellDef="let row;let i = index;" style="width: 10%;padding: 10px;">
          <button mat-raised-button color="primary" (click)="update(row)">
            <mat-icon>save</mat-icon>
            {{'submit' | translate}}
          </button>
        </td>
      </ng-container> -->

      <!-- <ng-container matColumnDef="approve" *ngIf="selectedStatus == 0">
        <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'approve' | translate}} </th>
        <td mat-cell *matCellDef="let row;let i = index;" style="width: 10%;padding: 10px;">
          <button mat-raised-button color="primary" (click)="approve(row)">
            <mat-icon>done</mat-icon>
            {{'approve' | translate}}
          </button>
        </td>
      </ng-container> -->

      <!-- <ng-container matColumnDef="deactivate">
        <th mat-header-cell *matHeaderCellDef style="width: 10%;">
        

          <span *ngIf="selectedStatus == 1 ">{{'unActive' | translate}}</span>
          <span *ngIf="selectedStatus == 0 ">{{'activate' | translate}}</span>

        </th>
        <td mat-cell *matCellDef="let row;let i = index;" style="width: 10%;padding: 10px;">
          <button mat-raised-button color="primary" (click)="onDeactivate(row.id,row.approved)">

            <mat-icon *ngIf="selectedStatus == 0">done</mat-icon>
            <mat-icon *ngIf="selectedStatus == 1">block</mat-icon>

            <span *ngIf="selectedStatus == 1 ">{{'unActive' | translate}}</span>
            <span *ngIf="selectedStatus == 0 ">{{'activate' | translate}}</span>

           
          </button>
        </td>
      </ng-container> -->

      <!-- <ng-container matColumnDef="delete">
        <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'delete' | translate}} </th>
        <td mat-cell *matCellDef="let row;let i = index;" style="width: 10%;padding: 10px;">
          <button mat-raised-button color="primary" (click)="onDelete(row.id)">
            <mat-icon>delete_forever</mat-icon>
            {{'delete' | translate}}
          </button>
        </td>
      </ng-container> -->

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}} "{{input.value}}"</td>
      </tr>
    </table>

    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>

    <app-matspinner [overlay]="spinnerOverlay"></app-matspinner>
  </div>



</div>

<!-- <div class="center"> -->

<!-- </div> -->



<ng-template #Modal>

  <h1 mat-dialog-title>{{'confirm' | translate}}</h1>
  <div mat-dialog-content>
    <p>{{'areYouSureToDelete' | translate}}</p>

  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
    <button mat-button cdkFocusInitial (click)="delete()">{{'yes' | translate}}</button>
  </div>

</ng-template>

<ng-template #ModalConfirmReset>

  <h1 mat-dialog-title>{{'resetPassword' | translate}}</h1>
  <div mat-dialog-content>
    <p>{{'areYouSureToResetPassword' | translate}}
      <br />
      {{userPhone + " - " + userfullName}}
    </p>

    <mat-form-field appearance="standard" style="width: 100%;">
      <mat-label>{{'newPassword' | translate}}</mat-label>
      <input matInput type="password" name="adminNewPassword" autocomplete="new-password"
        [(ngModel)]="adminNewPassword" required minlength="4" #adminNewPass="ngModel">
      <mat-error *ngIf="adminNewPass.hasError('required')">{{'requiredField' | translate}}</mat-error>
      <mat-error *ngIf="adminNewPass.hasError('minlength')">{{'passwordMinLength' | translate}}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="standard" style="width: 100%;">
      <mat-label>{{'confirmNewPassword' | translate}}</mat-label>
      <input matInput type="password" name="adminConfirmPassword" autocomplete="new-password"
        [(ngModel)]="adminConfirmPassword" required minlength="4" #adminConfirmPass="ngModel">
      <mat-error *ngIf="adminConfirmPass.hasError('required')">{{'requiredField' | translate}}</mat-error>
    </mat-form-field>

  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
    <button mat-raised-button color="primary" cdkFocusInitial (click)="confirmReset()"
      [disabled]="adminNewPass.invalid || adminConfirmPass.invalid">{{'yes' | translate}}</button>
  </div>

</ng-template>

<ng-template #ModalConfirmAssignAsMandoob>

  <h1 mat-dialog-title>{{'confirm' | translate}}</h1>
  <div mat-dialog-content>
    <p>{{'areYouSureToAssignAsMandoob' | translate}}
      <br />
      {{userPhone + " - " + userfullName}}
    </p>

  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
    <button mat-raised-button color="primary" cdkFocusInitial (click)="confirmAssignMandoob()">{{'yes' |
      translate}}</button>
  </div>

</ng-template>

<ng-template #editModal>

  <h1 mat-dialog-title>{{'update' | translate}}</h1>
  <div mat-dialog-content>

    <mat-form-field appearance="standard">
      <mat-label>{{'name' | translate}}</mat-label>
      <input matInput [(ngModel)]="editName">
      <!-- <mat-error *ngIf="arabName.invalid">{{'requiredField' | translate}}</mat-error> -->
    </mat-form-field>

    <mat-form-field appearance="standard">
      <mat-label>{{'email' | translate}}</mat-label>
      <input matInput [(ngModel)]="editEmail" #email="ngModel">
      <mat-error *ngIf="email.invalid">{{'requiredField' | translate}}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="standard">
      <mat-label>{{'mobileNo' | translate}}</mat-label>
      <input matInput [(ngModel)]="editMobile" #mobile="ngModel">
      <mat-error *ngIf="mobile.invalid">{{'requiredField' | translate}}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="standard">
      <mat-label>{{'address' | translate}}</mat-label>
      <input matInput [(ngModel)]="editAddress">
      <!-- <mat-error *ngIf="arabName.invalid">{{'requiredField' | translate}}</mat-error> -->
    </mat-form-field>

  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
    <button mat-button cdkFocusInitial (click)="updateUserInfo()">{{'submit' | translate}}</button>
  </div>

</ng-template>

<ng-template #ModalNewPassword>

  <h1 mat-dialog-title>{{'newPassword' | translate}}</h1>
  <div mat-dialog-content>
    <p style="font-weight: bolder;">
      {{newPassword}}
    </p>

  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
  </div>

</ng-template>

<ng-template #ModalConfirmLogoutFromAllDevices>

  <h1 mat-dialog-title>{{'confirm' | translate}}</h1>
  <div mat-dialog-content>
    <p>{{'areYouSureToLogoutFromAllDevices' | translate}}
      <br />
      {{userPhone + " - " + userfullName}}
    </p>

  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
    <button mat-raised-button color="primary" cdkFocusInitial (click)="confirmLogoutFromAllDevices()">{{'yes' |
      translate}}</button>
  </div>

</ng-template>